import React from 'react'
import { useSelector } from 'react-redux'
import { useMovieTrailer } from '../hooks/useMovieTrailer'

const VideoBackground = ({ movie_id }) => {

  const trailer = useSelector(store => store.movies?.trailerVideo)
  useMovieTrailer(movie_id)
  return (
    <div>
      <iframe className='w-screen aspect-video' src={"https://www.youtube.com/embed/" + trailer?.key + "?&autoplay=1&mute=1"} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" frameBorder="0" allowFullScreen></iframe>
    </div>
  )
}

export default VideoBackground